import InvoiceGeneratorTemplate from './templates/InvoiceGeneratorTemplate';
import { INVOICE_GENERATOR_CONFIG } from './config/invoiceGenerator';

export default function InvoiceGeneratorAT() {
  return <InvoiceGeneratorTemplate cfg={INVOICE_GENERATOR_CONFIG.AT} />;
}
